import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// translations
import ar from './translations/ar.json';
import en from './translations/en.json';
import cs from './translations/cs.json';
import da from './translations/da.json';
import de from './translations/de.json';
import es from './translations/es.json';
import fi from './translations/fi.json';
import fr from './translations/fr.json';
import it from './translations/it.json';
import no from './translations/no.json';
import nl from './translations/nl.json';
import pt from './translations/pt.json';
import sv from './translations/sv.json';

const resources = {
  ar: { translation: ar },
  en: { translation: en },
  cs: { translation: cs },
  da: { translation: da },
  de: { translation: de },
  es: { translation: es },
  fi: { translation: fi },
  fr: { translation: fr },
  it: { translation: it },
  no: { translation: no },
  nl: { translation: nl },
  pt: { translation: pt },
  sv: { translation: sv },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'cs', 'da', 'de', 'es', 'fi', 'fr', 'it', 'no', 'nl', 'pt', 'sv'],
    load: 'languageOnly',
    detection: { order: ['querystring', 'navigator'], caches: [], lookupQuerystring: 'lng' },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
